import { render, staticRenderFns } from "./PumpSetting.vue?vue&type=template&id=5a06b8cc&scoped=true&"
import script from "./PumpSetting.vue?vue&type=script&lang=js&"
export * from "./PumpSetting.vue?vue&type=script&lang=js&"
import style0 from "./PumpSetting.vue?vue&type=style&index=0&id=5a06b8cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06b8cc",
  null
  
)

export default component.exports